import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const DropshippingEcommerceWebsiteDevelopmentInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Dropshipping E-commerce Website Development in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Launch Your Dropshipping Store</Subheading>}
        heading={
          <Heading>
            Dropshipping <span tw="text-primary-500">E-commerce Websites</span>{" "}
            in Al Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset specializes in dropshipping e-commerce website
            development in **Al Barsha**, creating streamlined, scalable stores
            to help you start selling without inventory hassles.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1484807352052-23338990c6c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // E-commerce store visuals
          "https://images.unsplash.com/photo-1580674285054-bed31e145f59?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Shipping/logistics visuals
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Digital business working
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Dropshipping Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Dropshipping Made Simple"
        description="Our solutions empower your dropshipping success."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Supplier Integration",
            description: "Seamless product syncing.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Setup",
            description: "Launch your store quickly.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Automated Orders",
            description: "Streamline fulfillment processes.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Friendly",
            description: "Shop on any device.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Platform",
            description: "Safe transactions for trust.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Al Barsha Experts",
            description: "Local dropshipping pros.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Build</Subheading>}
        heading="Our Dropshipping E-commerce Development Process"
        description={
          <Description>
            We create efficient dropshipping stores:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Define your niche and suppliers.</li>
              <li>Design: Craft a user-friendly store layout.</li>
              <li>Development: Integrate dropshipping tools.</li>
              <li>Testing: Ensure smooth order automation.</li>
              <li>Launch: Deploy your ready-to-sell store.</li>
              <li>Support: Optimize based on performance.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1534452203293-494d7ddbf7e0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Online shopping
          "https://images.unsplash.com/photo-1566002181046-b3f5025e8f80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Boxes/dropshipping visuals
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team working
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Dropshipping Success in Al Barsha"
        description="Our stores drive results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Revenue Growth",
            description: "40% sales increase.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Launches",
            description: "Stores live in days.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "93% satisfaction rate.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Sell?</Subheading>}
        heading="Dropshipping E-commerce Websites in Al Barsha"
        description={
          <Description>
            MilaajBrandset offers expert dropshipping e-commerce website
            development in Al Barsha, helping you launch a profitable store with
            ease. Contact us to begin today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1518893494013-481c1d8ed3fd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team celebrating/business success
          "https://images.unsplash.com/photo-1627634777217-c864268db30f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Dropshipping concept
          "https://images.unsplash.com/photo-1524508762098-fd966ffb6ef9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Online business
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
